<script lang="ts" setup>
import type { HTMLAttributes } from "vue"
import { Input } from "~/components/ui/input"
import { cn } from "~/lib/utils"

const { class: cl } = defineProps<{
    class?: HTMLAttributes["class"]
}>()
</script>

<template>
    <Input
        v-bind="$attrs"
        :class="cn('text-base', cl)"
    />
</template>